import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createBlock(_component_a_tooltip, {
    title: _ctx.text,
    placement: "top",
    "arrow-point-at-center": "",
    visible: _ctx.tipVisible,
    "overlay-class-name": "fi-label-sub-tooltip"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        ref: "elRef",
        class: "fi-label-sub",
        style: _normalizeStyle({ color: _ctx.color, maxWidth: _ctx.maxWidthStyle }),
        onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args))),
        onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onLeave && _ctx.onLeave(...args)))
      }, _toDisplayString(_ctx.text), 37)
    ]),
    _: 1
  }, 8, ["title", "visible"]))
}